module.exports = __webpack_public_path__ + "img/ct_damre.f0b188f2.png";